var _class, _descriptor, _tokenExpirationTimeout, _IliosJWT_brand;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { get } from '@ember/object';
import { service } from '@ember/service';
import Base from 'ember-simple-auth/authenticators/base';
import jwtDecode from 'ilios-common/utils/jwt-decode';
import { cancel, later } from '@ember/runloop';
import { DateTime } from 'luxon';
let IliosJWT = (_class = (_tokenExpirationTimeout = /*#__PURE__*/new WeakMap(), _IliosJWT_brand = /*#__PURE__*/new WeakSet(), class IliosJWT extends Base {
  constructor(...args) {
    super(...args);
    _classPrivateMethodInitSpec(this, _IliosJWT_brand);
    _initializerDefineProperty(this, "iliosConfig", _descriptor, this);
    _classPrivateFieldInitSpec(this, _tokenExpirationTimeout, null);
  }
  async authenticate(credentials, headers) {
    let jwt;
    if ('jwt' in credentials) {
      jwt = credentials.jwt;
    } else {
      jwt = (await this.loginWithCredentials(credentials, headers)).jwt;
    }
    return _assertClassBrand(_IliosJWT_brand, this, _extractTokenAndSetupExpiration).call(this, jwt);
  }
  async invalidate() {
    // eslint-disable-next-line ember/no-runloop
    cancel(_classPrivateFieldGet(_tokenExpirationTimeout, this));
    _classPrivateFieldSet(_tokenExpirationTimeout, this, null);
  }
  async restore(data) {
    const now = DateTime.now().toUnixInteger();
    const jwt = get(data, 'jwt');
    let exp = get(data, 'exp');
    if (!exp) {
      // Fetch the expiration time from the token data since `exp` wasn't included in the data object that was passed in.
      const tokenData = jwtDecode(jwt);
      exp = tokenData['exp'];
    }
    if (exp > now) {
      this.scheduleAccessTokenExpiration(exp);
      return {
        jwt,
        exp
      };
    } else {
      throw new Error('token is expired');
    }
  }
  scheduleAccessTokenExpiration(expiresAt) {
    const now = DateTime.now().toUnixInteger();
    const wait = Math.max((expiresAt - now) * 1000, 0);

    // eslint-disable-next-line ember/no-runloop
    cancel(_classPrivateFieldGet(_tokenExpirationTimeout, this));
    _classPrivateFieldSet(_tokenExpirationTimeout, this, null);
    // eslint-disable-next-line ember/no-runloop
    _classPrivateFieldSet(_tokenExpirationTimeout, this, later(this, async () => {
      await this.invalidate();
      this.trigger('sessionDataInvalidated');
    }, wait));
  }
  async loginWithCredentials(data, loginHeaders) {
    const host = this.iliosConfig.apiHost ? this.iliosConfig.apiHost : '';
    const response = await fetch(`${host}/auth/login`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...loginHeaders
      },
      body: JSON.stringify(data)
    });
    const {
      statusText,
      status,
      headers
    } = response;
    const text = await response.text();
    const json = JSON.parse(text);
    if (!response.ok) {
      throw {
        statusText,
        status,
        headers,
        text,
        json
      };
    }
    const {
      exp
    } = jwtDecode(json.jwt);
    return {
      jwt: json.jwt,
      exp
    };
  }
}), _descriptor = _applyDecoratedDescriptor(_class.prototype, "iliosConfig", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
function _extractTokenAndSetupExpiration(jwt) {
  const {
    exp
  } = jwtDecode(jwt);
  this.scheduleAccessTokenExpiration(exp);
  return {
    jwt,
    exp
  };
}
export { IliosJWT as default };